import * as React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import cookies from 'js-cookie'
import { Field, reduxForm } from 'redux-form'
import { getFormValues } from 'redux-form/immutable'
import {
  Link,
  withRouter,
} from 'react-router-dom'
import InputField from '@App/components/fields/InputField'
import to from 'await-to-js'
import {
  Button,
} from 'relevant-ui'

import {
  SIGN_IN_FORM,
  SIGN_FORM_EMAIL_LABEL,
  SIGN_FORM_PASSWORD_LABEL,
  SUBMIT,
  RECOVERY_PASSWORD_ROUTE,
  RECOVERY_PASSWORD_LINK,
  HOMEPAGE_ROUTE,
} from '@App/constantes'

import { getSignInUser } from '@App/actions/logIn'
import {
  setShowDeleteModal,
} from '@App/store/modal'
import Confirm2FAForm from '../Confirm2FAForm'

import './styles.scss'

class LogInForm extends React.Component<any, any, any> {
  constructor(props: any) {
    super(props)

    this.state = {
      isLoaded: true,
      isUser: false,
    }

    this.submitForm = this.submitForm.bind(this)
    this.onRedirectToConnectPath = this.onRedirectToConnectPath.bind(this)
  }

  async submitForm() {
    const { signInUser, history } = this.props

    const email = this.props[SIGN_FORM_EMAIL_LABEL]
    const password = this.props[SIGN_FORM_PASSWORD_LABEL]

    const [, data]: any = await to(signInUser({ email, password }))

    if (!data || data instanceof Error) {
      return
    }

    if (Object?.entries(data).length === 0) {
      return this.setState({ isUser: true })
    }

    return this.onRedirectToConnectPath()
  }

  onRedirectToConnectPath() {
    if (this.props.location.search.includes('redirect')) {
      if (this.props.location.search.split('redirect=')[1] !== undefined) {
        return (window.location.href = `${
          this.props.location.search.split('redirect=')[1]
        }`)
      }
    }

    return this.props.history?.push('/home')
  }

  componentWillUnmount() {
    this.setState({
      isUser: false,
    })
  }

  render() {
    const { handleSubmit } = this.props

    if (!this.state.isUser) {
      return (
        <form
          className="loginForm"
          autoComplete="off"
          onSubmit={handleSubmit(this.submitForm)}
        >
          <Field
            component={InputField}
            name={SIGN_FORM_EMAIL_LABEL}
            label={SIGN_FORM_EMAIL_LABEL}
            primary
          />
          <Field
            type="password"
            component={InputField}
            name={SIGN_FORM_PASSWORD_LABEL}
            label={SIGN_FORM_PASSWORD_LABEL}
            primary
          />
          <div className="link">
            <Link to={RECOVERY_PASSWORD_ROUTE}>{RECOVERY_PASSWORD_LINK}</Link>
          </div>
          <div className="wrapperButton">
            <Button
              button="primary"
              size="large"
              type="submit"
              // disabled={submitting} TODO fix disabled submit
              label={SUBMIT}
            />
          </div>
        </form>
      )
    }

    return (
      <Confirm2FAForm
        email={this.props[SIGN_FORM_EMAIL_LABEL]}
        isLogin={true}
      />
    )
  }
}

const LogIn = reduxForm<any, any, any>({
  form: SIGN_IN_FORM,
  enableReinitialize: true,
})(LogInForm)

const mapStateToProps = (state: Object) => {
  const values = getFormValues(SIGN_IN_FORM)(state) || {}

  return {
    ...values,
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return {
    signInUser: ({ email, password }: { email: string, password: string }) => dispatch(getSignInUser({
      email,
      password,
    })),
    setShowDeleteModal: () => dispatch(setShowDeleteModal()),
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(LogIn)
